var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mt-sm mb-xl"},[_c('breadcrumbs',{attrs:{"history":_vm.breadcrumbs,"current":'Item #' + _vm.$route.params.variant,"hideBack":true}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }